// extracted by mini-css-extract-plugin
export var dark = "social-media-module--dark--fbcb3";
export var item = "social-media-module--item--4caf9";
export var link = "social-media-module--link--da261";
export var root = "social-media-module--root--355f5";